import { z } from "zod";

export const applyResignationSchema = z
  .object({
    email: z.string().min(1, "Email is required"),
    reason: z
      .string({
        required_error: "Reason is required",
        invalid_type_error: "Reason must be a string",
      })
      .nonempty("Reason is required"),
    otherReason: z.string().optional(),
    // remarks: z.string().min(1, "Remarks are required"),
    noticePeriodDays: z
      .number({
        required_error: "Notice period is required",
        invalid_type_error: "Notice period must be a valid number",
      })
      .min(1, "Notice period must be greater than 0")
      .refine((val) => !Number.isNaN(val), {
        message: "Notice period is required",
      }),
    buyoutDays: z
      .preprocess(
        (val) => {
          if (val === "" || val === null || typeof val === "undefined")
            return undefined;
          const parsed = Number(val);
          return isNaN(parsed) ? undefined : parsed;
        },
        z
          .number({
            required_error: "Buyout period days is required",
            invalid_type_error: "Buyout period days must be a valid number",
          })
          .min(1, "Buyout Days must be greater than 0")
      )
      .optional(),

    desiredLastWorkingDay: z
      .union([z.date(), z.null()]) // Allow null for the date field
      .refine((val) => val !== null, {
        message: "Desired Last Working Day is required",
      }),
    actualLastWorkingDay: z
      .union([z.date(), z.null()]) // Allow null for the date field
      .refine((val) => val !== null, {
        message: "Actual Last Working Day is required",
      }),
    buyout: z.boolean().optional().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.reason === "other" && !data.otherReason?.trim()) {
      ctx.addIssue({
        path: ["otherReason"],
        code: "custom",
        message: "Please provide a reason",
      });
    }
    if (data.buyout) {
      if (typeof data.buyoutDays !== "number" || isNaN(data.buyoutDays)) {
        ctx.addIssue({
          path: ["buyoutDays"],
          code: "custom",
          message: "Buyout Days are required when buyout is checked",
        });
      } else if (data.buyoutDays > data.noticePeriodDays) {
        ctx.addIssue({
          path: ["buyoutDays"],
          code: "custom",
          message: "Buyout Days cannot exceed Notice Period Days",
        });
      }
    }
  });
